import React from 'react';
import { Quote } from 'lucide-react';

export const HomeTestimonials = ({ testimonials }) => {
  if (!testimonials || testimonials.length === 0) return null;

  return (
    <section className="py-12 bg-[#0A0A0A]" data-testid="testimonials-section">
      <div className="px-6">
        <div className="text-center mb-8">
          <p className="text-sm uppercase tracking-[0.15em] text-[#BA1826] font-semibold mb-2">
            Voices of Impact
          </p>
          <h2 className="font-heading text-2xl sm:text-3xl font-bold text-white">
            Stories From Our Community
          </h2>
        </div>
        <div className="grid md:grid-cols-3 gap-5 max-w-3xl mx-auto">
          {testimonials.slice(0, 3).map((t) => (
            <div key={t.id} className="bg-white/5 border border-white/10 rounded-lg p-5 relative" data-testid={`testimonial-${t.id}`}>
              <Quote className="w-6 h-6 text-[#BA1826] mb-3 opacity-60" />
              <p className="text-white/90 text-sm leading-relaxed mb-4 italic">"{t.quote}"</p>
              <div className="flex items-center gap-3 mt-auto">
                <div className="w-8 h-8 bg-[#BA1826] rounded-full flex items-center justify-center text-white text-xs font-bold">
                  {t.name.charAt(0)}
                </div>
                <div>
                  <p className="text-white text-sm font-semibold">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.role}{t.country ? ` \u2014 ${t.country}` : ''}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
